import { render, staticRenderFns } from "./MaterialTemplate.vue?vue&type=template&id=5aa4c228&"
import script from "./MaterialTemplate.vue?vue&type=script&lang=js&"
export * from "./MaterialTemplate.vue?vue&type=script&lang=js&"
import style0 from "./MaterialTemplate.vue?vue&type=style&index=0&id=5aa4c228&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports